/**
 * THIS FILE IS AUTOGENERATED
 * Do not edit directly as it will be overwritten by the task that generated it
 */

import type { BrandThemeIcon } from '@jotta/types/Brand'
import { useBrandCode } from '../../hooks/useBrandTheme'
import { lazy, Suspense } from 'react'

const brandIcons = {
  ONLIME_WL: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-onlime" */ '@jotta/design-system/icons/onlime/ArrowsDownUp.svg'
      ),
  ),
  ELGIGANTEN: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-elgiganten" */ '@jotta/design-system/icons/elgiganten/ArrowsDownUp.svg'
      ),
  ),
  MEDIAMARKT: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-mediamarkt" */ '@jotta/design-system/icons/mediamarkt/ArrowsDownUp.svg'
      ),
  ),
  PHONERO: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-phonero" */ '@jotta/design-system/icons/phonero/ArrowsDownUp.svg'
      ),
  ),
  HALEBOP: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-halebop" */ '@jotta/design-system/icons/halebop/ArrowsDownUp.svg'
      ),
  ),
  ELKO: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-elko" */ '@jotta/design-system/icons/elko/ArrowsDownUp.svg'
      ),
  ),
  TELIA_CLOUD: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-teliacloud" */ '@jotta/design-system/icons/teliacloud/ArrowsDownUp.svg'
      ),
  ),
  GIGANTTI: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-gigantti" */ '@jotta/design-system/icons/gigantti/ArrowsDownUp.svg'
      ),
  ),
  LETS_GO: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-letsgo" */ '@jotta/design-system/icons/letsgo/ArrowsDownUp.svg'
      ),
  ),
  OBOS: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-obos" */ '@jotta/design-system/icons/obos/ArrowsDownUp.svg'
      ),
  ),
  TEST: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-test" */ '@jotta/design-system/icons/test/ArrowsDownUp.svg'
      ),
  ),
  SATURN: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-saturn" */ '@jotta/design-system/icons/saturn/ArrowsDownUp.svg'
      ),
  ),
  ELKJOP: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-elkjop" */ '@jotta/design-system/icons/elkjop/ArrowsDownUp.svg'
      ),
  ),
  GET: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-teliasky" */ '@jotta/design-system/icons/teliasky/ArrowsDownUp.svg'
      ),
  ),
  TDC_NO: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-tsky" */ '@jotta/design-system/icons/tsky/ArrowsDownUp.svg'
      ),
  ),
  COMHEM: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-tele2" */ '@jotta/design-system/icons/tele2/ArrowsDownUp.svg'
      ),
  ),
  JOTTACLOUD: lazy(
    () =>
      import(
        /* webpackChunkName: "icons-jottacloud" */ '@jotta/design-system/icons/jottacloud/ArrowsDownUp.svg'
      ),
  ),
}

const SvgArrowsDownUp: BrandThemeIcon = props => {
  const brandCode = useBrandCode()
  const Icon = brandIcons[brandCode]
  return (
    <Suspense>
      <Icon {...props} />
    </Suspense>
  )
}

export default SvgArrowsDownUp
